import React, { useEffect } from "react";
import { connect } from "react-redux";
import { AppState } from "../../store";
import { UserProfile } from "../../models/UserProfile";
import database from "../../Database";
import { logOut, setSyncStatus } from "./actions";
import { tryToConnect, initializeArcGISToken } from "./thunks";
import { handleArcGISAuthCallbackAndReload } from "../../arcgisUtils";
import { ReplicatorStatus } from "../../models/ReplicatorStatus";
import { URLOpenListenerEvent, App } from "@capacitor/app";

interface AppControlContainerProps {
    currentSyncStatus: ReplicatorStatus;
    logOut: typeof logOut;
    setSyncStatus: typeof setSyncStatus;
    tryToConnect: typeof tryToConnect;
    initializeArcGISToken: typeof initializeArcGISToken;
}

const AppControlContainer: React.FC<AppControlContainerProps> = ({
    currentSyncStatus,
    logOut,
    setSyncStatus,
    tryToConnect,
    initializeArcGISToken,
}) => {
    useEffect(() => {
        // Initialize ArcGIS authentication on app start
        initializeArcGISToken();

        // Set up URL listener for OAuth callbacks
        const setupUrlListener = async () => {
            const listener = await App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
                handleArcGISAuthCallbackAndReload(event.url);
            });
            return listener;
        };

        let urlListenerHandle: any;
        setupUrlListener().then((handle) => {
            urlListenerHandle = handle;
        });

        database.setReplicatorStatusChangeEventHandler((newStatus) => {
            setSyncStatus(newStatus);
        });

        return () => {
            database.setReplicatorStatusChangeEventHandler(undefined);
            if (urlListenerHandle) {
                urlListenerHandle.remove();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <></>;
};

const mapStateToProps = (state: AppState) => {
    return {
        currentSyncStatus: state.appControl.currentSyncStatus,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        logOut: () => dispatch(logOut()),
        setSyncStatus: (newStatus: ReplicatorStatus) => dispatch(setSyncStatus(newStatus)),
        tryToConnect: (userProfile: UserProfile) => dispatch(tryToConnect(userProfile)),
        initializeArcGISToken: () => dispatch(initializeArcGISToken()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppControlContainer);
